import { Globals } from '../globals'
import { getCleanObject } from '../utils/get-clean-object.ts'

type TrackedEventVersion = {
    readonly version: number
}

type TrackedEventSdk = {
    readonly name: string
    readonly version: string
    readonly library: string
    readonly library_version: string
}

/** @internal */
export type TrackedEventMeta = {
    readonly sdk: TrackedEventSdk
    readonly event: TrackedEventVersion
}

/** @internal */
export const buildTrackedEventMeta = (): TrackedEventMeta => {
    return getCleanObject({
        sdk: {
            name: Globals._libraryName,
            version: Globals._libraryVersion,
            library: Globals._coreName,
            library_version: Globals._coreVersion,
        },

        event: {
            version: 3,
        },
    })
}
